module.exports = __webpack_public_path__ + "static/media/matching-score-background.4a105a2b.mp3";